/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type User = {
    id?: number;
    username?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    password?: string;
    phone?: string;
    /**
     * dictionary:
     * * 1 READ
     * * 0 ADMIN
     *
     */
    role?: User.role;
};
export namespace User {
    /**
     * dictionary:
     * * 1 READ
     * * 0 ADMIN
     *
     */
    export enum role {
        '_0' = 0,
        '_1' = 1,
    }
}

